import React, { useState} from "react";
import "./../Componentes/www/pos-restaurante.css";
import { FOOTER_FACTURA_RESTAURANTE } from "./Util";
import {IconButton} from "@mui/material";
import { IconCheck, AmpliarDiv,IconChef, IconReceipt, IconSearch, IconUtensils, InvoiceIcon } from "./www/Icons";
import { MDBIcon } from "mdb-react-ui-kit";
import { Col,Row} from "reactstrap";
import { EXIT_IMAGE } from "./Image";
import { STATES_FAC_FACTURA } from "./States";
import {reactLocalStorage} from 'reactjs-localstorage';
export default function PantallaMesas(props) {
  const {
    dataRestaurante = [],
    dataMesas = [],
    dataCategoria = [],
    dataItems = [],
    dataOrdenesDetalle = [],
    formRestaurante,
    search,
    isResEditing,
    enableTab,
    usr_precio,
    usr_perfil,
    subtotal,
    itbms,
    total,
    setFormRestaurante,
    setFormFactura,
    fetchOrdenes,
    handleChange,
    addItemRestaurante,
    onClickEntregarOrden,
    onClickGuardarOrdenRestaurante,
    deleteRowRestaurant,
    handleSaveRowRestaurante,
    DATATABLE_RESTAURANTE,
    imgURLocalImage,
    LOGO_RESTAURANTE,
    dataCompania,
    setToken,
    setFormFacturaDetalle,
    usr_id
  } = props;
  const [isOpenMesasDiv, SetOpenMesasDiv] = useState(false)
  const getMesaStatus = (res_id) => {
    const orden = dataMesas.find((m) => m.ord_mesa === res_id);
    if (!orden) return "free";
    return orden.ordd_entregado === "1" ? "ready" : "cook";
  };

  const getMesaOrden = (res_id) => {
    const orden = dataMesas.find((m) => m.ord_mesa === res_id);
    if (!orden) return null;
    const id = orden.ord_identificador || orden.ordd_identificador || orden.identificador || "";
    const s = String(id);
    return s ? s.slice(-4) : null;
  };

  const hasMesa = formRestaurante.res_mesa_selected.length > 0;
  const totalMesas = dataRestaurante.length;
  const mesasLibres = dataRestaurante.filter((d) => getMesaStatus(d.res_id) === "free").length;
  const updateUsrIdLocal = (usr_perfil) => {
    const tokenActual = reactLocalStorage.getObject("tokenP");
    reactLocalStorage.setObject("tokenP", {
      ...tokenActual,
      usr_perfil
    });
    window.location.reload();
  };
  return (
    <div className="rt-pos">
      <header className="rt-topbar">
        <div className="rt-brand">
          <span className="rt-brand-icon">
            <img src={LOGO_RESTAURANTE} alt={dataCompania.com_nombre} />
          </span>
          <div>
            <h1 className="rt-brand-title">{dataCompania.com_nombre} </h1>
            <p className="rt-brand-sub">Toma de órdenes</p>
          </div>
        </div>
        <div className="rt-legend rt-legend--top">
          <span>
            <i className="rt-dot free" /> Libre
          </span>
          <span>
            <i className="rt-dot cook" /> En cocina
          </span>
          <span>
            <i className="rt-dot ready" /> Listo
          </span>
          <IconButton
            onClick={() => {
             updateUsrIdLocal("4")
            }}
          >
            <InvoiceIcon />
          </IconButton>
           <img src={EXIT_IMAGE} className="src-image" alt="..." 
                    onClick={()=>{      setFormFacturaDetalle(STATES_FAC_FACTURA({staneName:"formFacturaDetalle",usr_id}));}}/>
        </div>
      </header> 
      {!isOpenMesasDiv?<section className="rt-card rt-card-mesas"  onClick={() => SetOpenMesasDiv(!isOpenMesasDiv)}>
        <div className="rt-card-head" onClick={() => SetOpenMesasDiv(!isOpenMesasDiv)}>
          <h6 className="rt-card-title">Seleccionar mesa</h6>
          <div className="rt-mesa-selected">
          <span>
            {formRestaurante.res_nombre || "Sin mesa seleccionada"}
          </span>

          <IconButton
            className="rt-mesa-expand-btn"
            onClick={(e) => {
              e.stopPropagation();
              SetOpenMesasDiv(!isOpenMesasDiv);
            }}
          >
            <AmpliarDiv />
          </IconButton>
        </div>
          <div className="rt-mesas-count-box">
            <MDBIcon fas icon="users" />
            <span>
              <strong>{mesasLibres}</strong> libres · {totalMesas} en total
            </span>
          </div>
        </div>

        <div className="rt-mesas">
          {dataRestaurante.map((data, i) => {
            const status = getMesaStatus(data.res_id);
            const ordenNum = getMesaOrden(data.res_id);
            const selected = formRestaurante.res_mesa_selected === data.res_id;
            const label =
              status === "free"
                ? "Libre"
                : ordenNum
                  ? `Orden ${ordenNum}`
                  : status === "cook"
                    ? "En cocina"
                    : "Listo";
            return (
              <button
                key={i}
                className={`rt-mesa ${status} ${selected ? "selected" : ""}`}
                aria-pressed={selected}
                onClick={() => {
                  const primeraCategoria = dataCategoria[0];
                  fetchOrdenes({
                    res_id: data.res_id,
                    form: {
                      res_mesa_selected: data.res_id,
                      res_mesa_id: data.res_id,
                      res_nombre: data.res_nombre,
                      res_categoria_selected: primeraCategoria
                        ? primeraCategoria.cat_descripcion
                        : "",
                      res_categoria_id: primeraCategoria ? primeraCategoria.art_categoria : "",
                    },
                  });
                  setFormFactura({
                    res_mesa_selected: data.res_id,
                    res_mesa_id: data.res_id,
                    res_nombre: data.res_nombre,
                    res_categoria_selected: primeraCategoria
                      ? primeraCategoria.cat_descripcion
                      : "",
                    res_categoria_id: primeraCategoria ? primeraCategoria.art_categoria : "",
                  });
                }}
              >
                <div className="rt-mesa-top">
                  <span className="rt-mesa-name">{data.res_nombre}</span>
                  <span className={`rt-mesa-icon ${status}`}>
                    {status === "cook" ? (
                      <IconChef />
                    ) : status === "ready" ? (
                      <IconUtensils />
                    ) : (
                      <span className="rt-mesa-freedot" />
                    )}
                  </span>
                </div>
                <div className="rt-mesa-label">
                  {status !== "free" && <IconCheck />}
                  <span>{label}</span>
                </div>
              </button>
            );
          })}
        </div>
      </section>:<section className="rt-card rt-card-mesas-hidden rt-mesas-select-card"onClick={() => SetOpenMesasDiv(!isOpenMesasDiv)}>
      <Row className="align-items-center g-2">
        <Col xs={6}>
          <div className="rt-mesas-select-info">
            <div className="rt-mesas-select-icon">
              <MDBIcon fas icon="chair" />
            </div>
            <div>
              <h6 className="rt-card-title mb-1">Seleccionar mesa</h6>
              <span className="rt-mesas-subtitle">
                Elige una mesa para comenzar a tomar la orden
              </span>
            </div>
          </div>
        </Col>

    <Col xs={6}>
      <div className="rt-mesas-select-actions">

        <div className="rt-mesa-selected">
          <span>
            {formRestaurante.res_nombre || "Sin mesa seleccionada"}
          </span>

          <IconButton
            className="rt-mesa-expand-btn"
            onClick={(e) => {
              e.stopPropagation();
              SetOpenMesasDiv(!isOpenMesasDiv);
            }}
          >
            <AmpliarDiv />
          </IconButton>
        </div>

        <div className="rt-mesas-count-box">
          <MDBIcon fas icon="users" />
          <span>
            <strong>{mesasLibres}</strong> libres · {totalMesas} en total
          </span>
        </div>

      </div>
    </Col>

  </Row>
</section>}
      {hasMesa ? (
        <div className="rt-workspace">
          <div className={!isOpenMesasDiv?"rt-card rt-menu-card":"rt-card rt-menu-card2"}>
            <div className="rt-menu-head">
              <h6 className="rt-card-title"></h6>
              <label className="rt-search-wrap">
                <span className="rt-search-icon">
                  <IconSearch />
                </span>
                <input
                  id="search"
                  name="search"
                  type="text"
                  className="rt-search"
                  placeholder="Filtrar productos…"
                  value={search}
                  onChange={handleChange}
                />
                <span className="rt-sr-only">Filtrar productos del menú</span>
              </label>
            </div>

            <div className="rt-menu">
             <div className="rt-menu-categorias">
  <div className="rt-menu-header">
    <h5 className="rt-menu-title">Menú</h5>
    <span className="rt-menu-subtitle">Categorías</span>
  </div>

  <nav className="rt-cats" aria-label="Categorías del menú">
    {dataCategoria.map((data, a) => {
      const active =
        formRestaurante.res_categoria_id === data.art_categoria;

      return (
        <button
          key={a}
          type="button"
          className={`rt-cat ${active ? "active" : ""}`}
          aria-current={active ? "true" : undefined}
          onClick={() =>
            setFormRestaurante({
              ...formRestaurante,
              res_categoria_selected: data.cat_descripcion,
              res_categoria_id: data.art_categoria,
            })
          }
        >
          <span className="rt-cat-name">
            {data.cat_descripcion}
          </span>

          <span className="rt-cat-arrow" aria-hidden="true">
            ›
          </span>
        </button>
      );
    })}
  </nav>
</div>

              <div className="rt-items">
                {dataItems.map((data, a) => {
                  if (
                    data.art_categoria === formRestaurante.res_categoria_id &&
                    data.art_descripcion.toUpperCase().includes(search.toUpperCase())
                  ) {
                    return (
                      <button key={a} className="rt-item" onClick={() => addItemRestaurante(data)}>
                        <img
                          className="rt-item-img"
                          alt={data.art_descripcion}
                          src={imgURLocalImage + data.art_imgName}
                        />
                        <div className="rt-item-info">
                          <h6 className="rt-item-name">{data.art_descripcion}</h6>
                          <span className="rt-item-price">{"B/. " + data.art_precio}</span>
                        </div>
                        <span className="rt-item-add" aria-hidden="true">
                          +
                        </span>
                      </button>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          </div>

          <div className="rt-ticket">
            <div className="rt-ticket-head">
              <div className="rt-ticket-id">
                <span className="rt-ticket-icon">
                  <IconReceipt />
                </span>
                <div>
                  <p className="rt-ticket-mesa">{formRestaurante.res_nombre || "Sin mesa selecionada"}</p>
                  <p className="rt-ticket-orden">
                    Orden #{formRestaurante.current_ord_identificador.substring(10, 14)}
                  </p>
                </div>
              </div>
              <span className="rt-ticket-count">{dataOrdenesDetalle.length} ítems</span>
            </div>

            <div className="rt-ticket-body">
              <DATATABLE_RESTAURANTE
                deleteRow={deleteRowRestaurant}
                handleSaveRow={handleSaveRowRestaurante}
                dataOrdenes={dataOrdenesDetalle}
                enableTab={enableTab}
                usr_precio={usr_precio}
                isRestaurant={true}
                isEditing={isResEditing}
                ordd_entregado={isResEditing}
                isOpenMesasDiv={isOpenMesasDiv}
              />
            </div>

            <div className="rt-ticket-foot">
              <FOOTER_FACTURA_RESTAURANTE
                enableTab={enableTab}
                subtotal={subtotal}
                itbms={itbms}
                total={total}
                usr_perfil={usr_perfil}
              />

              <div className="rt-actions rt-actions-mobile">
                {dataOrdenesDetalle[0] !== undefined && isResEditing === false ? (
                  <button
                    className="rt-btn cocina"
                    onClick={() =>
                      dataOrdenesDetalle[0] !== undefined ? onClickGuardarOrdenRestaurante() : null
                    }
                  >
                    <IconChef /> Cocina
                  </button>
                ) : null}

                {hasMesa &&
                dataOrdenesDetalle[0] !== undefined &&
                isResEditing &&
                formRestaurante.ordd_entregado === "0" ? (
                  <button
                    className="rt-btn entregar"
                    onClick={() =>
                      dataOrdenesDetalle[0] !== undefined ? onClickEntregarOrden() : null
                    }
                  >
                    <IconUtensils /> Entregar
                  </button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="rt-empty">
          <img src={LOGO_RESTAURANTE || "/placeholder.svg"} alt="Restaurante" />
          <p>Selecciona una mesa para comenzar una orden</p>
        </div>
      )}
    </div>
  );
}
